import React from 'react';
import { useTranslation } from '@/i18n';

interface FlagProps {
  width?: number;
  height?: number;
  className?: string;
}

export const USFlag: React.FC<FlagProps> = ({ width = 24, height = 16, className = '' }) => {
  const { t } = useTranslation();
  const ariaLabelKey = 'common.flags.unitedStates';
  const ariaLabel = t(ariaLabelKey);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={ariaLabel === ariaLabelKey ? 'United States Flag' : ariaLabel}
    >
      {/* White background */}
      <rect width="24" height="16" fill="white" />
      
      {/* Red stripes */}
      <rect width="24" height="1.23" fill="#B22234" />
      <rect y="2.46" width="24" height="1.23" fill="#B22234" />
      <rect y="4.92" width="24" height="1.23" fill="#B22234" />
      <rect y="7.38" width="24" height="1.23" fill="#B22234" />
      <rect y="9.85" width="24" height="1.23" fill="#B22234" />
      <rect y="12.31" width="24" height="1.23" fill="#B22234" />
      <rect y="14.77" width="24" height="1.23" fill="#B22234" />
      
      {/* Blue canton */}
      <rect width="9.6" height="8.62" fill="#3C3B6E" />
      
      {/* Stars (simplified representation) */}
      <g fill="white">
        {/* Row 1 */}
        <circle cx="0.8" cy="0.72" r="0.3" />
        <circle cx="2.4" cy="0.72" r="0.3" />
        <circle cx="4.0" cy="0.72" r="0.3" />
        <circle cx="5.6" cy="0.72" r="0.3" />
        <circle cx="7.2" cy="0.72" r="0.3" />
        <circle cx="8.8" cy="0.72" r="0.3" />
        
        {/* Row 2 */}
        <circle cx="1.6" cy="1.44" r="0.3" />
        <circle cx="3.2" cy="1.44" r="0.3" />
        <circle cx="4.8" cy="1.44" r="0.3" />
        <circle cx="6.4" cy="1.44" r="0.3" />
        <circle cx="8.0" cy="1.44" r="0.3" />
        
        {/* Row 3 */}
        <circle cx="0.8" cy="2.16" r="0.3" />
        <circle cx="2.4" cy="2.16" r="0.3" />
        <circle cx="4.0" cy="2.16" r="0.3" />
        <circle cx="5.6" cy="2.16" r="0.3" />
        <circle cx="7.2" cy="2.16" r="0.3" />
        <circle cx="8.8" cy="2.16" r="0.3" />
        
        {/* Row 4 */}
        <circle cx="1.6" cy="2.88" r="0.3" />
        <circle cx="3.2" cy="2.88" r="0.3" />
        <circle cx="4.8" cy="2.88" r="0.3" />
        <circle cx="6.4" cy="2.88" r="0.3" />
        <circle cx="8.0" cy="2.88" r="0.3" />
        
        {/* Row 5 */}
        <circle cx="0.8" cy="3.6" r="0.3" />
        <circle cx="2.4" cy="3.6" r="0.3" />
        <circle cx="4.0" cy="3.6" r="0.3" />
        <circle cx="5.6" cy="3.6" r="0.3" />
        <circle cx="7.2" cy="3.6" r="0.3" />
        <circle cx="8.8" cy="3.6" r="0.3" />
        
        {/* Row 6 */}
        <circle cx="1.6" cy="4.32" r="0.3" />
        <circle cx="3.2" cy="4.32" r="0.3" />
        <circle cx="4.8" cy="4.32" r="0.3" />
        <circle cx="6.4" cy="4.32" r="0.3" />
        <circle cx="8.0" cy="4.32" r="0.3" />
        
        {/* Row 7 */}
        <circle cx="0.8" cy="5.04" r="0.3" />
        <circle cx="2.4" cy="5.04" r="0.3" />
        <circle cx="4.0" cy="5.04" r="0.3" />
        <circle cx="5.6" cy="5.04" r="0.3" />
        <circle cx="7.2" cy="5.04" r="0.3" />
        <circle cx="8.8" cy="5.04" r="0.3" />
        
        {/* Row 8 */}
        <circle cx="1.6" cy="5.76" r="0.3" />
        <circle cx="3.2" cy="5.76" r="0.3" />
        <circle cx="4.8" cy="5.76" r="0.3" />
        <circle cx="6.4" cy="5.76" r="0.3" />
        <circle cx="8.0" cy="5.76" r="0.3" />
        
        {/* Row 9 */}
        <circle cx="0.8" cy="6.48" r="0.3" />
        <circle cx="2.4" cy="6.48" r="0.3" />
        <circle cx="4.0" cy="6.48" r="0.3" />
        <circle cx="5.6" cy="6.48" r="0.3" />
        <circle cx="7.2" cy="6.48" r="0.3" />
        <circle cx="8.8" cy="6.48" r="0.3" />
      </g>
    </svg>
  );
};

export default USFlag;
